import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import Box, { BoxProps } from '@classify/react-core-components/Box';
import { SxProps, styled } from '@classify/react-core-components/styles';
export interface Props extends BoxProps {
  media?: ReactNode;
  children: ReactNode;
  isReverse?: boolean;
  sx?: SxProps;
}
const Content = styled(Box)({
  p: {
    maxInlineSize: 768
  }
});
const Narrative = t0 => {
  const $ = _c(14);
  const {
    media,
    children,
    isReverse,
    sx,
    className
  } = t0;
  const flexDirectionOverM = isReverse ? "row-reverse" : "row";
  let t1;
  if ($[0] !== flexDirectionOverM) {
    t1 = {
      xs: "column",
      md: flexDirectionOverM
    };
    $[0] = flexDirectionOverM;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      md: "center"
    };
    t3 = {
      xs: 3,
      sm: 4,
      lg: 8
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== sx) {
    t4 = {
      ...sx
    };
    $[4] = sx;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children) {
    t5 = <Content flex={1}>{children}</Content>;
    $[6] = children;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = media && media;
  let t7;
  if ($[8] !== className || $[9] !== t1 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = <Box data-testid="narrative-root" display="flex" flexDirection={t1} alignItems={t2} gap={t3} sx={t4} className={className}>{t5}{t6}</Box>;
    $[8] = className;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default Narrative;